import React, { FC } from 'react';
import { IconCardT } from '@components/Organisms/IconCardList/types';
import { fromMarkdown, renderParagraphs } from '@lib/utils';
import Image from 'next/image';

export const IconCard: FC<IconCardT> = ({ heading, body, icon, display }) => {
  if (!display) return null;

  return (
    <div className="grid-item">
      {icon?.url && (
        <Image src={icon.url} alt={icon.alternativeText} width={'65x'} height={'65px'} />
      )}
      <h3>{fromMarkdown({ text: heading })}</h3>
      <p>{renderParagraphs({ body })}</p>
    </div>
  );
};
